/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPASSETTYPE } from './IAPASSETTYPE';
import {
    IAPASSETTYPEFromJSON,
    IAPASSETTYPEFromJSONTyped,
    IAPASSETTYPEToJSON,
} from './IAPASSETTYPE';

/**
 * 
 * @export
 * @interface InvestmentDetailsIncomeAssetSplitViewModel
 */
export interface InvestmentDetailsIncomeAssetSplitViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeAssetSplitViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeAssetSplitViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeAssetSplitViewModel
     */
    splitPercentage?: number;
    /**
     * 
     * @type {IAPASSETTYPE}
     * @memberof InvestmentDetailsIncomeAssetSplitViewModel
     */
    assetTypeId: IAPASSETTYPE;
}

/**
 * Check if a given object implements the InvestmentDetailsIncomeAssetSplitViewModel interface.
 */
export function instanceOfInvestmentDetailsIncomeAssetSplitViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;
    isInstance = isInstance && "assetTypeId" in value;

    return isInstance;
}

export function InvestmentDetailsIncomeAssetSplitViewModelFromJSON(json: any): InvestmentDetailsIncomeAssetSplitViewModel {
    return InvestmentDetailsIncomeAssetSplitViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsIncomeAssetSplitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsIncomeAssetSplitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'assetCode': json['AssetCode'],
        'splitPercentage': !exists(json, 'SplitPercentage') ? undefined : json['SplitPercentage'],
        'assetTypeId': IAPASSETTYPEFromJSON(json['AssetTypeId']),
    };
}

export function InvestmentDetailsIncomeAssetSplitViewModelToJSON(value?: InvestmentDetailsIncomeAssetSplitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'AssetCode': value.assetCode,
        'SplitPercentage': value.splitPercentage,
        'AssetTypeId': IAPASSETTYPEToJSON(value.assetTypeId),
    };
}

